import { arrayRange } from './helpers';
import { IAlphabetType } from '@/interfaces/alphabet.interface';

const BOOKS_FOR_PAGE = 15;
const SERIES_FOR_PAGE = 30;
const AUTHORS_FOR_PAGE = 30;
const PRERENDER_PAGES = 2;
const ARTICLES_FOR_BLOG_PAGE = 10;

const DAYS = arrayRange(1, 31, 1);
const MONTHS = [
  { name: 'Январь', value: '01' },
  { name: 'Февраль', value: '02' },
  { name: 'Март', value: '03' },
  { name: 'Апрель', value: '04' },
  { name: 'Май', value: '05' },
  { name: 'Июнь', value: '06' },
  { name: 'Июль', value: '07' },
  { name: 'Август', value: '08' },
  { name: 'Сентябрь', value: '09' },
  { name: 'Октябрь', value: '10' },
  { name: 'Ноябрь', value: '11' },
  { name: 'Декабрь', value: '12' },
];

const MONTH_NAMES = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];

const YEARS = arrayRange(1923, 2018, 1);
const GENDER = [
  { name: 'Мужской', value: 'male' },
  { name: 'Женский', value: 'female' },
];

const ABSOLUTE_URL = 'https://fantasy-worlds.ru';
const DEV_ABSOLUTE_URL = '';
// Переменная для разработки, абсолютным url - для картинок/фрагментов текста/аудио
// const DEV_ABSOLUTE_URL = ABSOLUTE_URL;

//LFROMS
const HEADER_BANNER_LFROM = '1256959329';
const BOOK_CARD_ITEM__LFROM = '974764102';
const BOOK_WIDGET_LFROM = '974764102';
const READER_WIDGET_LFROM = '974764102';
const BOOK_BTN_LFROM = '1255590659';
const BTN_READ_ONLINE_LFROM = '1142890034';
const FOOTER_LITRES_LFROM = '1258056564';
const PARTNER_BOOKS_LFROM = '1257096209';

const config = {
  headers: {
    Accept: '/',
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
    'Access-Control-Allow-Headers': 'Authorization',
  },
};

const API_URL = `https://fantasy-worlds.ru/api/v1/`;

const REVALIDATE_TIME = 300;

const alphabet: IAlphabetType = {
  ru_a: 'А',
  ru_b: 'Б',
  ru_v: 'В',
  ru_g: 'Г',
  ru_d: 'Д',
  ru_e: 'Е',
  ru_zh: 'Ж',
  ru_z: 'З',
  ru_i: 'И',
  ru_y: 'Й',
  ru_k: 'К',
  ru_l: 'Л',
  ru_m: 'М',
  ru_n: 'Н',
  ru_o: 'О',
  ru_p: 'П',
  ru_r: 'Р',
  ru_s: 'С',
  ru_t: 'Т',
  ru_u: 'У',
  ru_f: 'Ф',
  ru_h: 'Х',
  ru_tz: 'Ц',
  ru_ch: 'Ч',
  ru_sh: 'Ш',
  ru_sz: 'Щ',
  ru_bh: 'Ъ',
  ru_bi: 'Ы',
  ru_bs: 'Ь',
  ru_ie: 'Э',
  ru_yu: 'Ю',
  ru_ia: 'Я',
  en_a: 'A',
  en_b: 'B',
  en_c: 'C',
  en_d: 'D',
  en_e: 'E',
  en_f: 'F',
  en_g: 'G',
  en_h: 'H',
  en_i: 'I',
  en_j: 'J',
  en_k: 'K',
  en_l: 'L',
  en_m: 'M',
  en_n: 'N',
  en_o: 'O',
  en_p: 'P',
  en_q: 'Q',
  en_r: 'R',
  en_s: 'S',
  en_t: 'T',
  en_u: 'U',
  en_v: 'V',
  en_w: 'W',
  en_x: 'X',
  en_y: 'Y',
  en_z: 'Z',
};

const LITRES_AUTHORS = ['dem-mihaylov', 'tala-tocka', 'mayk-omer', 'ayrin-laks', 'andrey-usachev', 'lu-cysin'];

const MENU_LINKS = [
  { name: 'Главная', link: '/' },
  { name: 'Новинки', link: '/new' },
  { name: 'Библиотека', link: '/lib' },
  { name: 'Аудиокниги', link: '/lib/type/audio' },
  { name: 'Вебтуны', link: '/webtoons' },
  { name: 'Бесплатные книги', link: '/free-books' },
  { name: 'Жанры', link: '/genre-fantasy' },
  { name: 'Cерии', link: '/series' },
  { name: 'Подкасты', link: '/lib/podcasts' },
  { name: 'Краткий пересказ', link: '/retelling' },
  { name: 'Черновики', link: '/drafts' },
  { name: 'Блог', link: '/blog' },
  { name: 'Все жанры', link: '/genre' },
  { name: 'Комментарии', link: '/comments' },
  { name: 'Обратная связь', link: '/mail' },
];

const GENRES_FANTASY_LINKS = [
  { name: 'Боевое фэнтези', link: '/genre/boevoe_fentezi', img: '/images/genres-icons/battle-icon.svg', className: 'list__item_battle' },
  { name: 'Любовное фэнтези', link: '/genre/lubov', img: '/images/genres-icons/love-icon.svg', className: 'list__item_love' },
  { name: 'Фэнтези про драконов', link: '/genre/drakony', img: '/images/genres-icons/dragon-icon.svg', className: 'list__item_dragon' },
  { name: 'Русское фэнтези', link: '/genre/russkoe', img: '/images/genres-icons/rus-icon.svg', className: 'list__item_rus' },
  { name: 'Юмористическое фэнтези', link: '/genre/umoristicheskoe', img: '/images/genres-icons/humor-icon.svg', className: 'list__item_humor' },
  { name: 'Попаданцы', link: '/genre/popadancy', img: '/images/genres-icons/traveler-icon.svg', className: 'list__item_traveler' },
  { name: 'Книги про волшебников', link: '/genre/volshebniki', img: '/images/genres-icons/wizard-icon.svg', className: 'list__item_wizard' },
  { name: 'Городское фэнтези', link: '/genre/gorodskoe', img: '/images/genres-icons/city-icon.svg', className: 'list__item_city' },
  { name: 'Книги про вампиров', link: '/genre/vampiry', img: '/images/genres-icons/vampire-icon.svg', className: 'list__item_vampiry' },
  { name: 'Зарубежное фэнтези', link: '/genre/knigi_fentezi_zarubezhnye', img: '/images/genres-icons/world-icon.svg', className: 'list__item_world' },
  { name: 'Детективное фэнтези', link: '/genre/detective_fentezi', img: '/images/genres-icons/detective-icon.svg', className: 'list__item_detective' },
  { name: 'Героическое фэнтези', link: '/genre/geroicheskoe_fentezi', img: '/images/genres-icons/helmet-icon.svg', className: 'list__item_helmet' },
  { name: 'Фанфик', link: '/genre/fanfik', img: '/images/genres-icons/flame-icon.svg', className: 'list__item_fanfik' },
  { name: 'Магические академии', link: '/genre/magicheskie-akademii', img: '/images/genres-icons/castle-icon.svg', className: 'list__item_academy' },
];

const GENRES_FANTASTIC_LINKS = [
  { name: 'Юмористическая фантастика', link: '/genre/umoristicheskaya', img: '/images/genres-icons/humor-icon.svg', className: 'list__item_humor' },
  { name: 'Социальная фантастика', link: '/genre/socialnaya', img: '/images/genres-icons/social-icon.svg', className: 'list__item_social' },
  { name: 'Космическая фантастика', link: '/genre/kosmicheskaya', img: '/images/genres-icons/planet-icon.svg', className: 'list__item_planet' },
  { name: 'Детективная фантастика', link: '/genre/detektivnaya', img: '/images/genres-icons/detective-icon.svg', className: 'list__item_detective' },
  { name: 'Героическая фантастика', link: '/genre/geroicheskaya', img: '/images/genres-icons/cosmonaut-icon.svg', className: 'list__item_cosmonaut' },
  { name: 'Научная фантастика', link: '/genre/nauchnaya', img: '/images/genres-icons/robot-icon.svg', className: 'list__item_robot' },
  { name: 'Киберпанк', link: '/genre/kiberpank', img: '/images/genres-icons/cyborg-icon.svg', className: 'list__item_cyborg' },
  { name: 'Cтимпанк', link: '/genre/stimpank', img: '/images/genres-icons/gear-icon.svg', className: 'list__item_gear' },
];

const REG_EXP_WEB_LINK = /^((ftp|http|https):\/\/)?(www\.)?([A-Za-zА-Яа-я0-9]{1}[A-Za-zА-Яа-я0-9\-]*\.?)*\.{1}[A-Za-zА-Яа-я0-9-]{2,8}(\/([\w#!:.?+=&%@!\-\/])*)?/;

export {
  BOOKS_FOR_PAGE,
  AUTHORS_FOR_PAGE,
  DAYS,
  MONTHS,
  YEARS,
  GENDER,
  MONTH_NAMES,
  API_URL,
  PRERENDER_PAGES,
  ARTICLES_FOR_BLOG_PAGE,
  DEV_ABSOLUTE_URL,
  SERIES_FOR_PAGE,
  REVALIDATE_TIME,
  LITRES_AUTHORS,
  MENU_LINKS,
  ABSOLUTE_URL,
  HEADER_BANNER_LFROM,
  BOOK_CARD_ITEM__LFROM,
  BOOK_WIDGET_LFROM,
  READER_WIDGET_LFROM,
  BOOK_BTN_LFROM,
  BTN_READ_ONLINE_LFROM,
  FOOTER_LITRES_LFROM,
  PARTNER_BOOKS_LFROM,
  GENRES_FANTASY_LINKS,
  GENRES_FANTASTIC_LINKS,
  REG_EXP_WEB_LINK,
  config,
  alphabet,
};
